export default __webpack_public_path__ + "static/media/hakket_8_procent_fedt.c726700b.jpg";